import { useState } from "react";
import { AdaptedButton } from "../../components/adaptedButton";
import { StyleSheet, View, ScrollView } from "react-native";


export function Page7({ handleClick }) {

  const [selectedValues, setSelectedValues] = useState([]);
  const handleButtonClick = (name, value) => {
    const newSelectedValues = [...selectedValues];
    const valueIndex = newSelectedValues.indexOf(value);
    if (valueIndex === -1) {
      // Add value to selected values
      newSelectedValues.push(value);
    } else {
      // Remove value from selected values
      newSelectedValues.splice(valueIndex, 1);
    }
    setSelectedValues(newSelectedValues);
    handleClick(name, newSelectedValues);
  };
  return (
    <ScrollView
    style={{height: '100%'}}>
      <View style={styles.center}> 
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Dryness'}
            selected={selectedValues.includes('Dryness')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Skin flaking'}
            selected={selectedValues.includes('Skin flaking')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Redness'}
            selected={selectedValues.includes('Redness')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Irritation'}
            selected={selectedValues.includes('Irritation')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Sunburn'}
            selected={selectedValues.includes('Sunburn')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Windburn'}
            selected={selectedValues.includes('Windburn')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Rash'}
            selected={selectedValues.includes('Rash')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Enlarged pores'}
            selected={selectedValues.includes('Enlarged pores')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Wrinkles'}
            selected={selectedValues.includes('Wrinkles')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Fine Lines'}
            selected={selectedValues.includes('Fine Lines')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Dark circles'}
            selected={selectedValues.includes('Dark circles')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Black heads'}
            selected={selectedValues.includes('Black heads')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'White heads'}
            selected={selectedValues.includes('White heads')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Acne'}
            selected={selectedValues.includes('Acne')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Dullness'}
            selected={selectedValues.includes('Dullness')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Uneven tone'}
            selected={selectedValues.includes('Uneven tone')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Rough texture'}
            selected={selectedValues.includes('Rough texture')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Hyperpigmentation'}
            selected={selectedValues.includes('Hyperpigmentation')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Melasma'}
            selected={selectedValues.includes('Melasma')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Excess oil / shine'}
            selected={selectedValues.includes('Excess oil / shine')}
          />
        </View>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Uncomfortable tightness'}
            selected={selectedValues.includes('Uncomfortable tightness')}
          />
        </View>
        <View style={styles.fix}>
          <AdaptedButton
            handleClick={handleButtonClick}
            field={'skin_concerns'}
            fieldValue={'Sag / Loss of elasticity'}
            selected={selectedValues.includes('Sag / Loss of elasticity')}
          />
        </View>
      </View>
      </View>
    </ScrollView>
  );
}


const styles = StyleSheet.create({
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fix: {
    width: '48%',
    margin: 2,
  }
});